import React from 'react';
import { useAppSelector } from '@pomofocus/shared-client';
import { withRouter } from 'react-router-dom';
import GlobalModals from './GlobalModals';
const GlobalModalsContainer = () => {
    const visibleModal = useAppSelector((state) => state.global.visibleModal);
    const configObj = useAppSelector((state) => state.config);
    return (React.createElement(GlobalModals, { visibleModal: visibleModal, configObj: configObj }));
};
export default withRouter(GlobalModalsContainer);
